import styled from '@emotion/styled';
import { Button, Paper } from '@mui/material';
import { OptimizedImage } from '@web/common/components/optimized-image';
import {
  productKindDetails,
  productKindToQueryDict,
  SelectableProductKinds,
} from '@web/store/store-product-options';
import NextLink from 'next/link';
import { FC, MouseEvent } from 'react';

interface ProductKindFilterProps {
  selectedKind?: string;
  onKindChange?: (
    e: MouseEvent<HTMLButtonElement>,
    key?: SelectableProductKinds,
  ) => Promise<void> | void;
}

const ProductKindsFilterBar = styled(Paper)`
  ${props => props.theme.breakpoints.down('sm')} {
    display: none;
  }
  flex: 1;
  display: flex;
  padding: ${props => props.theme.spacing(1)};
  margin-bottom: ${props => props.theme.spacing(2)};
  & > a,
  & > button {
    flex: 1;
    height: auto;
    :not(:last-child) {
      margin-right: ${props => props.theme.spacing(1)};
    }
  }
`;

const FilterButton = styled(Button)`
  width: 100%;
  height: 100%;
  font-weight: normal;
  & svg {
    display: flex;
    /* TODO Remove this style when the SVG classes are standardized */
    .a {
      fill: ${props =>
        props.color === 'primary'
          ? props.theme.palette[props.color!].contrastText
          : '#777'} !important;
    }
  }
`;

const KindIcon = styled(OptimizedImage)`
  img {
    display: flex;
  }
`;

export const ProductKindFilter: FC<ProductKindFilterProps> = ({ onKindChange, selectedKind }) => {
  return (
    <ProductKindsFilterBar variant="outlined">
      <NextLink href="/loja" passHref>
        <FilterButton
          startIcon={<KindIcon src="/icons/all-categories.svg" ext="svg" />}
          variant={selectedKind == null ? 'contained' : 'text'}
          color={selectedKind == null ? 'primary' : 'inherit'}
        >
          Todas as categorias
        </FilterButton>
      </NextLink>
      {Object.entries(productKindDetails).map(([key, { label, icon }]) => (
        <NextLink
          href={`/loja/categoria/${productKindToQueryDict[key as SelectableProductKinds]}`}
          passHref
          key={`l-${key}`}
        >
          <FilterButton
            startIcon={<KindIcon src={icon} ext="svg" />}
            variant={selectedKind === key ? 'contained' : 'text'}
            color={selectedKind === key ? 'primary' : 'inherit'}
            onClick={
              onKindChange != null ? e => onKindChange(e, key as SelectableProductKinds) : undefined
            }
            key={key}
          >
            {label}
          </FilterButton>
        </NextLink>
      ))}
    </ProductKindsFilterBar>
  );
};
